(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["compare"] && !Shopify.designMode) return;
  try {
    
function initOttoPts(root) {
  if (root.dataset.ptsReady) return;
  root.dataset.ptsReady = 'true';
  const variants = JSON.parse(root.querySelector('[data-color-config]').textContent);
  const layers = [...root.querySelectorAll('.ow-color-finish')];
  const swatches = [...root.querySelectorAll('.ow-color-swatch')];
  const name = root.querySelector('.ow-color-name');
  const accent = root.querySelector('.ow-color-accent');
  const stage = root.querySelector('.ow-color-stage');
  const pause = root.querySelector('.ow-color-pause');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  let index = 0;
  let timer;
  let paused = reduced;
  let phase = 'bare';
  let pending = null;
  const later = (fn, delay) => { clearTimeout(timer); pending = fn; if (!paused && !document.hidden) timer = setTimeout(fn, delay); };
  const select = () => swatches.forEach((button, n) => button.setAttribute('aria-pressed', String(n === index)));
  const reveal = () => {
    phase = 'finish';
    layers.forEach((image, n) => image.classList.toggle('is-visible', n === index));
    name.textContent = variants[index].name;
    accent.textContent = '';
    stage.setAttribute('aria-label', variants[index].name);
    root.dataset.phase = phase;
    root.dataset.color = variants[index].id;
    select();
    later(strip, 3300);
  };
  const strip = () => {
    phase = 'bare';
    layers.forEach(image => image.classList.remove('is-visible'));
    name.textContent = root.dataset.bare;
    accent.textContent = '';
    stage.setAttribute('aria-label', root.dataset.bare);
    root.dataset.phase = phase;
    index = (index + 1) % variants.length;
    select();
    later(reveal, 2500);
  };
  const updatePause = () => {
    pause.setAttribute('aria-pressed', String(paused));
    pause.setAttribute('aria-label', paused ? root.dataset.play : root.dataset.pause);
  };
  pause.addEventListener('click', () => {
    paused = !paused;
    updatePause();
    if (paused) clearTimeout(timer);
    else later(pending || reveal, 500);
  });
  swatches.forEach((button, n) => button.addEventListener('click', () => {
    clearTimeout(timer);
    index = n;
    select();
    layers.forEach(image => image.classList.remove('is-visible'));
    phase = 'bare';
    root.dataset.phase = phase;
    name.textContent = root.dataset.bare;
    accent.textContent = root.dataset.reveal + ' ' + variants[index].name;
    stage.setAttribute('aria-label', root.dataset.bare);
    pending = reveal;
    timer = setTimeout(reveal, reduced ? 0 : 1450);
  }));
  document.addEventListener('visibilitychange', () => {
    clearTimeout(timer);
    if (!document.hidden && !paused) later(pending || reveal, 700);
  });
  updatePause();
  select();
  root.dataset.phase = 'bare';
  Promise.all(layers.map(image => image.decode().catch(() => {}))).then(() => {
    if (reduced) reveal();
    else later(reveal, 1300);
  });
}
function initOttoPtsWithin(scope) { scope.querySelectorAll('.ow-color-carousel').forEach(initOttoPts); }
initOttoPtsWithin(document);
document.addEventListener('shopify:section:load', event => initOttoPtsWithin(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
		constructor() {
			super()
		}

		connectedCallback() {
			this.header = document.querySelector('.shopify-section-header')
			this.headerWrapper = document.querySelector('.header-wrapper')
			this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always'
			this.headerBounds = {}
			this.currentScrollTop = 0
			this.preventReveal = false
			this.predictiveSearch = this.querySelector('predictive-search')

			this.onScrollHandler = this.onScroll.bind(this)
			this.hideHeaderOnScrollUp = () => (this.preventReveal = true)

			this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
			window.addEventListener('scroll', this.onScrollHandler, false)

			this.createObserver()
		}

		disconnectedCallback() {
			this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
			window.removeEventListener('scroll', this.onScrollHandler)
		}

		createObserver() {
			let observer = new IntersectionObserver((entries, observer) => {
				this.headerBounds = entries[0].intersectionRect
				observer.disconnect()
			})

			if (this.header) {
				observer.observe(this.header)
			}
		}

		onScroll() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop

			if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
				this.header.classList.add(
					'shopify-section-header-sticky',
					'shopify-section-header-always-sticky',
				)
				this.header.classList.remove('color-background-3')
				this.header.style.transition =
					'background var(--duration-short), transform var(--duration-default)'
			}

			if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
				this.header.classList.remove('shopify-section-header-sticky')
				this.header.style.transition = 'background var(--duration-short)'
				if (this.header.classList.contains('color-background-1')) {
					this.header.classList.add('color-background-3')
				}
			}

			if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				if (this.preventHide) return
				requestAnimationFrame(this.hide.bind(this))
			} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				if (!this.preventReveal) {
					requestAnimationFrame(this.reveal.bind(this))
				} else {
					window.clearTimeout(this.isScrolling)

					this.isScrolling = setTimeout(() => {
						this.preventReveal = false
					}, 66)

					requestAnimationFrame(this.hide.bind(this))
				}
			} else if (scrollTop <= this.headerBounds.top) {
				requestAnimationFrame(this.reset.bind(this))
			}

			this.currentScrollTop = scrollTop
		}

		hide() {
			if (this.headerIsAlwaysSticky) return
			this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky')
			this.closeMenuDisclosure()
		}

		reveal() {
			if (this.headerIsAlwaysSticky) return
			this.header.classList.add('shopify-section-header-sticky', 'animate')
			this.header.classList.remove('shopify-section-header-hidden', 'color-background-3')
		}

		reset() {
			if (this.headerIsAlwaysSticky) return
			this.header.classList.remove(
				'shopify-section-header-hidden',
				'shopify-section-header-sticky',
				'animate',
			)
			if (this.header.classList.contains('color-background-1')) {
				this.header.classList.add('color-background-3')
			}
		}

		closeMenuDisclosure() {
			this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure')
			if (this.disclosures) {
				this.disclosures.forEach((disclosure) => {
					disclosure.close()
				})
			}
			this.disclosureLists = this.header.querySelectorAll('.disclosure__list')
			if (this.disclosureLists) {
				this.disclosureLists.forEach((disclosureList) => {
					disclosureList.setAttribute('hidden', true)
				})
			}
		}
	}

	customElements.define('sticky-header', StickyHeader)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
	constructor() {
		super();
	}

	hide() {
		super.hide();
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	showActiveMedia() {
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);

		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

customElements.define('product-modal', ProductModal);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ow-home-panels"] && !Shopify.designMode) return;
  try {
    
function initOttoHomePreviews(root) {
root.querySelectorAll('.ow-entry__card--video').forEach((card) => {
  if (card.dataset.previewBound) return;
  card.dataset.previewBound = 'true';
  const video = card.querySelector('.ow-entry__video');
  if (!video) return;

  let hovered = false;
  let request = 0;
  const wantsPreview = () => !document.hidden &&
    (hovered || card.matches(':focus-visible'));

  const updatePreview = () => {
    const currentRequest = ++request;
    if (!wantsPreview()) {
      card.classList.remove('is-preview-playing');
      video.pause();
      if (video.readyState > 0) video.currentTime = 0;
      return;
    }

    video.muted = true;
    video.play().then(() => {
      if (request === currentRequest && wantsPreview()) {
        card.classList.add('is-preview-playing');
      }
    }).catch(() => {

      if (request === currentRequest) card.classList.remove('is-preview-playing');
    });
  };

  card.addEventListener('pointerenter', (event) => {
    if (event.pointerType === 'touch') return;
    hovered = true;
    updatePreview();
  });
  card.addEventListener('pointerleave', () => {
    hovered = false;
    updatePreview();
  });
  card.addEventListener('focus', updatePreview);
  card.addEventListener('blur', updatePreview);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) hovered = false;
    updatePreview();
  });
});

}
initOttoHomePreviews(document);
document.addEventListener('shopify:section:load', (event) => initOttoHomePreviews(event.target));


  } catch(e) { console.error(e); }
})();
})();
